var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { useSearch } from "@react-components/modules/Search/useSearch";
var initialContext = {
    handleSearch: function () { return ({}); },
    searchedTerm: "",
    isLastPage: false,
    searchCollection: {},
    isValidating: false,
    size: 0,
    setNodeId: function () { return void ""; },
    setSearchLocation: function () { return void ""; },
    nodeId: 0,
    siteId: 0,
    searchLocation: "internal",
};
var SearchContext = createContext(initialContext);
var SearchProvider = function (_a) {
    var siteId = _a.siteId, _b = _a.pageSize, pageSize = _b === void 0 ? 12 : _b, initialSearchParams = _a.initialSearchParams, fallbackData = _a.fallbackData, children = _a.children, initialSearchLocation = _a.initialSearchLocation;
    var _c = useSearch({
        pageSize: pageSize,
        siteId: siteId,
        initialSearchParams: initialSearchParams,
        fallbackData: fallbackData,
        initialSearchLocation: initialSearchLocation,
    }), handleSearch = _c.handleSearch, isValidating = _c.isValidating, searchedTerm = _c.searchedTerm, isLastPage = _c.isLastPage, searchCollection = _c.searchCollection, setSize = _c.setSize, size = _c.size, setNodeId = _c.setNodeId, nodeId = _c.nodeId, searchLocation = _c.searchLocation, setSearchLocation = _c.setSearchLocation;
    return (_jsx(SearchContext.Provider, __assign({ value: {
            handleSearch: handleSearch,
            isValidating: isValidating,
            searchedTerm: searchedTerm,
            isLastPage: isLastPage,
            searchCollection: searchCollection,
            setSize: setSize,
            size: size,
            setNodeId: setNodeId,
            nodeId: nodeId,
            siteId: siteId,
            searchLocation: searchLocation,
            setSearchLocation: setSearchLocation,
        } }, { children: children }), void 0));
};
export { SearchProvider, SearchContext };
